export const overlayCloseReasons = {
  INTERACT_OUTSIDE: 'interact_outside',
  INTERACT_PARENT: 'interact_parent',
  ESCAPE: 'escape',
  SCROLL: 'scroll',
};
